<template>
    <section class="workspace-dashboard__metrics">
        <v-card
            v-for="card in usageCards"
            :key="card.id"
            class="workspace-dashboard__metric-card"
            elevation="0"
        >
            <div class="workspace-dashboard__metric-icon" :class="`tone-${card.tone}`">
                <v-icon>{{ card.icon }}</v-icon>
            </div>
            <div class="workspace-dashboard__metric-content">
                <span :title="card.help || card.label">{{ card.label }}</span>
                <strong>{{ card.value }}</strong>
                <small>{{ card.detail }}</small>
                <small v-if="card.secondary">{{ card.secondary }}</small>
                <div v-if="card.progress !== null" class="workspace-dashboard__progress">
                    <div
                        class="workspace-dashboard__progress-bar"
                        :style="{ width: `${card.progress}%` }"
                    ></div>
                </div>
                <em v-if="card.remaining">{{ card.remaining }}</em>
            </div>
        </v-card>
    </section>
</template>

<script>
export default {
    name: 'DashboardSummaryCards',
    props: {
        usageCards: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
